<script setup lang="ts">
import { onMounted, ref } from 'vue';
import { requirejs } from '~/modules/require';
import { readCookie } from '~/modules/cookies-services';
import vuIcon from '@ds/vuekit/src/components/vu-icon.vue';

const currentLanguage = ref('en');

type LanguageSelectorOptions = {
  icon?: string;
  hidePrependIcon?: boolean;
};

const { icon = 'expand-down', hidePrependIcon = false } = defineProps<LanguageSelectorOptions>();

const displayLanguageSelectorModal = async () => {
  const [LanguagePicker, MP3DPData, UWPI18n] = await requirejs<[any, any, any, any]>([
    'DS/W3DXComponents/LanguagePicker',
    'DS/MP3DPApplicationStore/MP3DPData',
    'DS/UWPClientCode/I18n',
  ]);

  const languagePicker = new LanguagePicker({
    availableLanguagesGetter() {
      const languages = UWPI18n.getSupportedLanguages();
      // Remove non-traducted languages
      delete languages.cs;
      delete languages.ko;
      delete languages.pl;
      delete languages.ru;
      delete languages['pt-BR'];
      delete languages['zh-TW'];
      delete languages.tr;
      return languages;
    },
    currentLanguageGetter: () => currentLanguage.value,
    currentLanguageSetter: UWPI18n.setCurrentLanguage,
    passportUrl: await MP3DPData._getServiceUrl('3DPASSPORT'),
  });

  languagePicker.render().inject(document.body);
  languagePicker.show();
};

onMounted(() => {
  currentLanguage.value = readCookie('swymlang') || 'en';
});
</script>
<template>
  <div
    class="flex align-items-center justify-center grid-gap-5px pointer"
    @click="() => displayLanguageSelectorModal()"
  >
    <span class="fonticon fonticon-language" v-if="!hidePrependIcon" />
    <span class="selected-language">{{ currentLanguage }}</span>
    <vu-icon :icon="icon" />
  </div>
</template>
<style scoped lang="css">
.selected-language {
  text-transform: uppercase;
  font-family: Arial;
}
</style>
